module.exports = __webpack_public_path__ + "img/chapter-test-on-st.png";